import * as React from 'react'
import { getBellringerSetNumber, getGraduationYears, getPeriods, getStatsForAllQuestions, getStatsForAllQuestionsPerPeriod, getStatsForSetAndSubject } from '../../../services/bellringers'
import GradesViewForTeacher from './GradesViewForTeacher'
import CollapsableCard, { CollapsableCardBody, CollapsableCardHeader } from '../../../components/CollapsableCard/CollapsableCard'

interface Props {
    grades: number[]
    info: any
    onQuestionClick: (bellringerId: string, period: string) => void
}

interface State {

}

export function BellringerTable({ weeks, periods }) {
    return (
        <table
            style={{
            borderCollapse: 'collapse',
            width: '100%',
            }}
        >
            <thead>
                <tr>
                    <th style={cellStyle}>Week</th>

                    {periods.map((period) => (
                        <th key={period} style={cellStyle}>
                            {period}
                        </th>
                    ))}
                </tr>
            </thead>

            <tbody>
                {weeks.map((week) => (
                    <tr key={week}>
                    <td style={cellStyle}>{week}</td>

                    {periods.map((period) => (
                        <td key={`${week}-${period}`} style={cellStyle}>
                        Info: {week} - {period}
                        </td>
                    ))}
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

const cellStyle: React.CSSProperties = {
    border: '1px solid #ccc',
    padding: '8px',
    textAlign: 'center',
}

export default class BellringersSubjectSubview extends React.Component<Props, State> {

    render() {
        let {grades, info, onQuestionClick} = this.props
        let {subject, studentsInfo, questionsStats} = info
        let periods = getPeriods(studentsInfo)

        return ( 
            <>
                { grades.map((grade, index) => {
                    let setNumber = getBellringerSetNumber(grade) // Grade 9 -> Set 1 (this is recently changed to be displayed as Set #s)
                    let title = `Set ${setNumber}`
                    let statsForSet = getStatsForSetAndSubject(questionsStats, setNumber, subject)

                    return (
                        <div className="bellringers-table bellringers-teacher-grades-view mb-2 pb-1">
                           <GradesViewForTeacher 
                                key={`bellringers-teacher-grades-card-${index}`}
                                subject={subject}
                                grade={grade}
                                setNumber={setNumber}
                                ribbonColor={subject}
                                title={title}
                                collapsed={false}
                                periods={periods}
                                stats={statsForSet}
                                onQuestionClick={onQuestionClick}
                           />
                        </div>
                    )}
                )}
            </>
        )
    }
}


